/*
 *@Description: 布控管理-表格列配置
 *@Author: zhengff
 *@Date: 2019-04-26 21:55:36
*/
import {Dic} from '$utils'
import i18n from '@src/common/lib/i18n'
// 特征option
export const SearchFilter =()=>{
    return[
  {
    label: i18n.t('personCm.label.name'),
    prop: 'name',
    span: 6,
    clearable: true,
    placeholder: i18n.t('personCm.placeholder.name')
  },
  // {
  //   label: '布控时间',
  //   prop: 'daterange',
  //   type: 'daterange',
  //   span: 8,
  //   clearable: true
  // },
  {
    label: i18n.t('personCm.label.state'),
    prop: 'status',
    type: 'select',
    span: 4,
    placeholder: i18n.t('personCm.placeholder.state'),
    dicData: [
        {
            label: i18n.t('personCm.placeholder.unlimited'),
            value: 3
        },
        {
            label: i18n.t('personCm.placeholder.enabled'),
            value: 1
        },
        {
            label: i18n.t('personCm.placeholder.disable'),
            value: 2
        },
      ],
    clearable: true
  },
  {
    label: i18n.t('personCm.label.groups'),
    prop: 'repositoriesCode',
    formslot: true,
    span: 6
  },
  {
    label: '',
    prop: 'searchForm',
    formslot: true,
    span: 6
  }
]
}